var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMastercard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4911 14.2778H18.4346V33.2556H29.4911V14.2778Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.622 23.7666C19.622 20.0332 21.2545 16.5332 24.0001 14.2777C19.0283 10.1554 11.7562 11.0888 7.82338 16.2999C3.89052 21.511 4.78098 29.1332 9.75272 33.2554C13.9082 36.6777 19.7704 36.6777 24.0001 33.2554C21.2545 30.9999 19.622 27.4999 19.622 23.7666Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5124 31.2333V30.8444H41.6608V30.7666H41.2898V30.8444H41.4382L41.5124 31.2333ZM42.2545 31.2333V30.7666H42.106L41.9576 31.0777L41.8092 30.7666H41.6608V31.2333H41.735V30.8444L41.8834 31.1555H41.9576L42.106 30.8444V31.2333H42.2545Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6254 23.7666C42.6254 30.4554 37.5053 35.8221 31.1237 35.8221C28.5265 35.8221 26.0035 34.8888 24 33.2554C28.9717 29.1332 29.8622 21.5888 25.9293 16.2999C25.3357 15.5221 24.742 14.8999 24 14.2777C28.9717 10.1554 36.2438 11.0888 40.1767 16.2999C41.735 18.3999 42.6254 21.0443 42.6254 23.7666Z",
    fill: "#F79E1B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mastercard.f5c6e4c8fd24004686fb3feb66caade1.svg";